export default __webpack_public_path__ + "static/media/Flavoured coffee.1aaa22f6.png";